<div class="logo-img main-container">
  <a routerLink="/dashboard">
    <img alt="Evolution logo" src="assets/img/logo.png" width="400" />
  </a>
  <h6>
    <span>{{ traineeName }}</span>
    <fa-icon [icon]="['far', 'user-circle']"></fa-icon>
  </h6>
</div>

<router-outlet></router-outlet>
